import getCookie from '@/service/getCookie'

export default function copyCookie (oldName, newName, newExpire, noUrlAppend, noSecureAppend){
let urlAppend = ''
let secureAppend = ';secure=true'
let domainAppend = ';domain=.cathaylife.com.tw'
if(window.location.href.indexOf('tmycrm') !== -1){
    urlAppend = '.T'
}else if(window.location.href.indexOf('smycrm') !== -1){
    urlAppend = '.S'
}else if (window.location.href.indexOf('mycrm') !== -1) {
    // do nothing
}else{
    secureAppend = ''
    domainAppend = ''
}

if(noUrlAppend === true){
    urlAppend = "";
}

if(noSecureAppend === true){
    secureAppend = "";
}

document.cookie = newName + urlAppend + "=" + getCookie(oldName, false) + (newExpire ? ";expires=" + newExpire : "") + ";path=/" + domainAppend + secureAppend;
}